<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!--<a-button type="primary">Button></a-button>-->
    <!--<hello-vue></hello-vue>-->
    <!--<HelloWorld></HelloWorld>-->
    <router-view class="view"></router-view>
    <!--<login></login>-->
    <!--<router-view/>-->
    <!--<MainLayout></MainLayout>-->
  </div>
</template>

<script>
import AButton from 'ant-design-vue/es/button/button'
import helloVue from './components/helloVue'
import HelloWorld from './components/HelloWorld'
import Login from './components/Login'
import MainLayout from './components/MainLayout'
import ChatroomList from './components/ChatroomList'
import BotManage from './components/BotManage'
import LogManage from './components/LogManage'
import BindClientModal from './components/BindClientModal'
import newBotModal from './components/newBotModal'
import BindTags from './components/BindTags'
import ChattingModal from './components/ChattingModal'

export default {
  name: 'App',
  components: {HelloWorld, AButton, helloVue, Login, MainLayout, ChatroomList, BotManage, BindClientModal, newBotModal, BindTags, ChattingModal, LogManage}
}
</script>

<style>
#app {
  font-size: 14px;
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: Monospaced Number,Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.avatar-36-con{
  display: flex;
  align-items: center;
}
.avatar-36-con .avatar{
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
label {
  cursor: default;
}
label.info:after {
  content: ":";
  margin: 0 8px 0 2px;
  position: relative;
  top: -.5px;
  box-sizing: border-box;
}
.avatar-36-con .nickname{
  margin-left: 10px;
}
.ant-collapse-content {
  border-top: 0;
}
</style>
